module.exports = __webpack_public_path__ + "2d441b4e40b86e25ecb6f62fd9dede16.png";